<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Search Result</div>
            </div>
            <div class="admin-page-content"> <!--class = "admin-page-content sidebar-right"-->
                <!--page content-->
                <div class="internal-container contact-container">
                    <!-- Search Result -->
                    <!-- <template>
                        <swiper class="" :options="swiperOptionDepartments" ref="swiperDepartment">
                            <template v-for="(dept, index) in departmentData">
                                <swiper-slide class="dept" :id="'dept_'+dept.department_id" v-bind:key="'dept_'+index">
                                    <span class="dept_name" v-on:click.prevent="selectDepartment(dept.department_id)">
                                        
                                    </span>
                                </swiper-slide>
                            </template>
                        </swiper>
                    </template> -->
                    <div class="app-filter-good-table-container">
                        <!-- List Content Here -->
                        <vue-good-table
                            ref="ContactExtensionList"
                            mode="remote"
                            title="Search List"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            @on-row-click="onRowClick"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                            }"

                            :search-options="{
                            enabled: false,
                            }">
                    </vue-good-table>
                </div>
            </div>
        </div>
        <!--page content-->
        <div class="page-sidebar" v-if="hideShowFlag && windowWidth > 767">
            <div class="contactInfoBtn" v-on:click.prevent="showContact()" >
                <i class="openCloseBtn fa fa-caret-right"></i>
            </div>
            <div class="contactDetails">
                <template v-if="userData.id != 0 ">
                    <div class="sidebar-locations">
                        {{userData.user}}
                    </div>
                    <template v-if="userData.note != '' || userData.address_line != '' || userData.email != '' || userData.contacts.length > 0">
                        <div v-if="userData.address_line != ''" class="sidebar-locations-details">
                            <img src="/static/images/map-pin.png">
                            {{userData.address_line}}
                        </div>
                        <div v-if="userData.note != ''" class="sidebar-locations-details mt-0">
                            {{userData.note}}
                        </div>
                        <div class="primary-contact">
                            <p >Email :</p> <strong>{{userData.email}}</strong>
                        </div>
                        <template v-if="userData.contacts.length > 0">
                            <ul>
                                <template v-for="(cont, index1) in userData.contacts">
                                    <li>
                                        <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                        {{cont.contact}}
                                    </li>                                    
                                </template>
                            </ul>
                        </template>
                    </template>
                    <template v-else>
                        <div class="sidebar-locations-details">
                            {{noDataMessaage}}
                        </div>    
                    </template>
                    <div class="sidebar-locations">
                        {{userData.department_name}}
                    </div>
                    <template v-if="userData.department_note != '' || userData.department_address_line != '' || userData.department_contacts.length > 0">
                        <div v-if="userData.department_address_line != ''" class="sidebar-locations-details">
                            <img src="/static/images/map-pin.png">
                            {{userData.department_address_line}}
                        </div>
                        <div v-if="userData.department_note != ''" class="sidebar-locations-details mt-0">
                            {{userData.department_note}}
                        </div>
                        <template v-if="userData.department_contacts.length > 0">
                            <ul>
                                <template v-for="(cont, index1) in userData.department_contacts">
                                    <li>
                                        <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                        {{cont.contact}}
                                    </li>                                    
                                </template>
                            </ul>
                        </template>
                    </template>
                    <template v-else>
                        <div class="sidebar-locations-details">
                            {{noDataMessaage}}
                        </div>    
                    </template>
                    <div class="sidebar-locations">
                        {{userData.site_name}}
                    </div>
                    <template v-if="userData.site_note != '' || userData.site_address_line != '' || userData.site_contacts.length > 0">
                        <div v-if="userData.site_address_line != ''" class="sidebar-locations-details">
                            <img src="/static/images/map-pin.png">
                            {{userData.site_address_line}}
                        </div>
                        <div v-if="userData.site_note != ''" class="sidebar-locations-details mt-0">
                            {{userData.site_note}}
                        </div>
                        <template v-if="userData.site_contacts.length > 0">
                            <ul>
                                <template v-for="(cont, index1) in userData.site_contacts">
                                    <li>
                                        <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                        {{cont.contact}}
                                    </li>                                    
                                </template>
                            </ul>
                        </template>
                    </template>
                    <template v-else>
                        <div class="sidebar-locations-details">
                            {{noDataMessaage}}
                        </div>    
                    </template>
                </template>
            </div>
        </div>
    </div>
    <app-backend-footer></app-backend-footer>
</div>
<!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'app-backend-footer': BackendFooter,
            swiper,
            swiperSlide,
        },
        mixins: [SessioMixin],
        data() {
            return {
                hideContactflag: false,
                noDataMessaage: 'Details not available',
                userData: {
                    id: 0
                },
                windowWidth: 0,
                hideShowFlag: true,
                departmentData: [{}],
                department_id: 0,
                location: '',
                searchSlug: '',
                selected_menu_data: '',
                user_name: '',
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                swiperOptionDepartments: {
                    slidesPerView: 6,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 5.5
                        },
                        1400: {
                            slidesPerView: 5.3
                        },
                        1300: {
                            slidesPerView: 4.7
                        },
                        1200: {
                            slidesPerView: 3.5
                        },
                        1000: {
                            slidesPerView: 3.2
                        },
                        667: {
                            slidesPerView: 3.2
                        },
                        480: {
                            slidesPerView: 2.3
                        },
                        360: {
                            slidesPerView: 1.5
                        }
                    }
                },
                sitesArr: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Username',
                        field: 'user',
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: 'Post',
                        field: 'post',
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: 'Extension',
                        field: 'contact',
                        filterable: false,
                        sortable: true,
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'updated_at',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin(window.location.href);
            var contactDetailOpen = localStorage.getItem("contact_detail_open");
            if (contactDetailOpen == 'true') {
                self.hideContactflag = false;
            } else {
                self.hideContactflag = true;
            }
        },
        mounted: function () {
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                }
            });
            self.searchSlug = this.$route.params.slug;
            EventBus.$emit("searchText", self.searchSlug);
            //alert(self.searchSlug);
            self.$nextTick(function () {
                self.loadSearchUserData();
            });
            self.getPermissions();
            self.showContact(self.hideContactflag);
            self.setWidthToContactContainer(550);
        },
        watch: {
            '$route'(to, from) {
                self.serverParams = {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'user',
                        type: 'asc',
                    },
                };
                self.searchSlug = this.$route.params.slug;
                EventBus.$emit("searchText", self.searchSlug);
                self.$nextTick(function () {
                    self.loadSearchUserData();
                });
            }
        },
        methods: {
            showContact(hide) {
                hide = (hide === null || typeof (hide) === "undefined" || hide == '') ? false : hide;
                if (hide) {
                    window.localStorage.setItem("contact_detail_open", false);
                    self.hideContactflag = true;
                    $('.contactDetails').fadeOut();
                    setTimeout(function () {
                        $('.page-sidebar').addClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').removeClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-right');
                        $('.openCloseBtn').addClass('fa-caret-left');
                    }, 300);
                } else {
                    var classavailable = $('.page-sidebar').attr('class');
                    if (typeof (classavailable) != 'undefined') {
                        if (classavailable.indexOf('zeroWidth') > 0) {
                            window.localStorage.setItem("contact_detail_open", true);
                            self.hideContactflag = false;
                            $('.page-sidebar').removeClass('zeroWidth');
                            if (self.windowWidth > 767) {
                                $('.page-sidebar').show();
                                $('.internal-container').addClass('openDetailview');
                            } else {
                                $('.page-sidebar').hide();
                            }
                            $('.openCloseBtn').removeClass('fa-caret-left');
                            $('.openCloseBtn').addClass('fa-caret-right');
                            $('.contactDetails').fadeIn();
                        } else {
                            window.localStorage.setItem("contact_detail_open", false);
                            self.hideContactflag = true;
                            $('.contactDetails').fadeOut();
                            setTimeout(function () {
                                $('.page-sidebar').addClass('zeroWidth');
                                if (self.windowWidth > 767) {
                                    $('.page-sidebar').show();
                                    $('.internal-container').removeClass('openDetailview');
                                } else {
                                    $('.page-sidebar').hide();
                                }
                                $('.openCloseBtn').removeClass('fa-caret-right');
                                $('.openCloseBtn').addClass('fa-caret-left');
                            }, 300);
                        }
                    } else {
                        window.localStorage.setItem("contact_detail_open", true);
                        self.hideContactflag = false;
                        $('.page-sidebar').removeClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').addClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-left');
                        $('.openCloseBtn').addClass('fa-caret-right');
                        $('.contactDetails').fadeIn();
                    }
                }
                self.setWidthToContactContainer(350);
            },
            onRowClick(params) {
                self.userData = params.row;
                if (self.windowWidth > 767) {
                    if ($('.page-sidebar').attr('class').indexOf('zeroWidth') != -1) {
                        $('.contacttDetails').hide();
                        /*self.showContact();*/
                    }
                } else {
                    /* If Data available then hide it */
                    if ($(params.event.target.closest('.clickable').nextSibling).hasClass("contacttDetails")) {
                        $(params.event.target.closest('.clickable').nextSibling).remove();
                        return;
                    }

                    if (self.userData.id) {
                        /* generate html */
                        var html = '<tr class="contacttDetails">';
                        html += '<td colspan="' + self.columns.length + '">';
                        /* html += '<label>' + self.userData.user + '</label>';
                         html += '<p><span class="fa fa-map-marker" aria-hidden="true"></span>';
                         html += self.userData.address_line + '</p>'; 
                         html += '<p>Note : ' + self.userData.note + '</p>'; */
                        html += '<table class="table">';
                        if (self.userData.address_line.length) {
                            html += '<tr><td>Address</td><td>' + self.userData.address_line + '</td></tr>';
                        }
                        if (self.userData.note.length) {
                            html += '<tr><td>Note</td><td>' + self.userData.note + '</td></tr>';
                        }
                        html += '<tr><td>Email</td><td><a href="mailto:' + self.userData.email + '">' + self.userData.email + '</a></td></tr>';
                        html += '<tr><td>Extension</td><td>' + self.userData.contact + '</td></tr>';
                        $.each(self.userData.contacts, function (i) {
                            html += '<tr><td>' + self.userData.contacts[i].contact_label + '</td>';
                            html += '<td>' + self.userData.contacts[i].contact + '</td></tr>';
                        });
                        html += '</table>';
                        html += '</td>';
                        html += '</tr>';
                        $(html).insertAfter(params.event.target.closest('.clickable'));
                    }
                }
            },
            selectDepartment(id) {
                $('.contacttDetails').hide();
                if (self.department_id) {
                    /*self.showContact(true);*/
                    self.userData = {id: 0};
                }
                self.department_id = id;
                self.$nextTick(function () {
                    self.loadSearchUserData();
                });
            },
            addContact() {
                self.$router.push('/backend/addcontact');
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadSearchUserData();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadSearchUserData();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('user');
                    field: ('note');
                    field: ('email');
                    field: ('post');
                    field: ('contact');
                    field: ('site_name');
                    field: ('department_name');
                    field: ('updated_at');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.post || filters.email || filters.note || filters.user || filters.id || filters.contact || filters.site_name || filters.department_name || filters.updated_at || filters.updated_by) {
                    self.loadSearchUserData();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['ContactExtensionList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadSearchUserData();
            },
            loadSearchUserData: function () {
                $('.contacttDetails').hide();
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        // department_id: self.department_id,
                        // site_id: self.location,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        // filters: self.serverParams.columnFilters,
                        // messageData: self.message,
                        sort: self.serverParams.sort,
                        strSearch: self.searchSlug,
                    }
                };
                self.showLoader();
                HTTP.get('universal_search', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                if (self.totalRecords > 0) {
                                    self.hideShowFlag = true;
                                    self.userData = self.rows[0];
                                } else {
                                    self.hideShowFlag = false;
                                }

                            }
                            self.hideLoader();
                            /* self.$nextTick(function () {
                             self.toSlide();
                             }); */
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }

                        })
            },
            toSlide: function () {
                if (typeof (self.departmentData) != 'undefined') {
                    if (self.departmentData.length > 0) {
                        $('.dept').removeClass("ActiveDept");
                        $.each(self.departmentData, function (key_sub, value_dept) {
                            if (self.department_id == value_dept.department_id) {
                                self.$refs.swiperDepartment.swiper.slideTo(value_dept.slide_id, 0);
                                $('#dept_' + self.department_id).addClass("ActiveDept");
                            }
                        });
                    }
                }
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/SearchUserData.vue